import { render, staticRenderFns } from "./SyncWithSettingsEditor.vue?vue&type=template&id=5fcca476&scoped=true"
import script from "./SyncWithSettingsEditor.vue?vue&type=script&lang=js"
export * from "./SyncWithSettingsEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcca476",
  null
  
)

export default component.exports